export default "__VITE_ASSET__BnO642UG__"